import ScrollAnimation from 'react-animate-on-scroll';
import Button from "../button/button";
import contactImage from "../../assets/contact.webp";
import "./full-width-cta.css";

export default function FullWidthCta({ ctaText, buttonText, buttonLink, theme }: { ctaText: string, buttonText: string, buttonLink: string, theme: string }) {
  return (
    <ScrollAnimation animateIn="fadeIn"animateOnce= {true}>
      <div className={`ae-full-width-cta -${theme}`}>
        <img className="ae-full-width-cta-image" src={contactImage} alt=""/>
        <div className="ae-full-width-cta-text-container">
          <h2 className="ae-full-width-cta-h2">Talk to us.</h2>
          <p className="ae-full-width-cta-p">{ctaText}</p>
          <Button
            buttonText={buttonText}
            buttonLink={buttonLink}
            theme="dark-theme"
          />
        </div>
      </div>
    </ScrollAnimation>
  )
}